import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import "./App.css";
import Product from "./Components/QR/Product";
import Homepage from "./Components/Home/Homepage";
import Header from "./Components/Header";
import Footer from "./Components/Footer";

function App() {
  return (
    <div className="App">
      <div className="body_content">
        <Router>
          <Header />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/products/:productName" element={<Product />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </div>
      <Footer />
    </div>
  );
}

export default App;
